<template>
  <page-view avatar="/avatar2.jpg" :title="false">
    <div slot="headerContent">
      <div class="title">{{ timeFix }}，{{ user.username }}<span class="welcome-text">，{{ welcome }}</span></div>
      <div> 胜鑫园林工程管理平台，通过该平台可以管理项目上的资源，包括人工、资金、机械等资源的使用情况。最后能够统计出工程里的各项成本花费，生成报表</div>
      <div> &nbsp;</div>
    </div>
    <div slot="extra">
      <a-row class="more-info">
      </a-row>
    </div>

    <div>
      <a-row :gutter="24">
        <a-col :xl="22" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" title="预警信息" :bordered="false">
            <!--            <a-list :dataSource="correctErrorList" :pagination="pagination">-->
            <a-list :dataSource="warningList" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <!--                <a slot="actions" @click="receive(item)">收到</a>-->
                <a-list-item-meta :description="item.content">
                  <div slot="title">{{ item.title }}</div>
                  <a-avatar
                    slot="avatar"
                    style="backgroundColor:#fffd64"
                  >
                    <a-icon type="warning" style="color: orangered"/>
                  </a-avatar>
                </a-list-item-meta>
              </a-list-item>
              <div v-if="warnLoading && !busy" class="demo-loading-container">
                <a-spin/>
              </div>
            </a-list>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <!--    <template slot="footer">-->
    <!--      <div>-->
    <!--        <a-button @click="handleCancel">取消</a-button>-->
    <!--      </div>-->
    <!--    </template>-->
  </page-view>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapState } from 'vuex'

import { PageView } from '@/layouts'
import HeadInfo from '@/components/tools/HeadInfo'
import { Radar } from '@/components'
import { receive, getPage } from '@/api/warning/warning'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'Warning',
  directives: { infiniteScroll },
  components: {
    PageView,
    HeadInfo,
    Radar
  },
  data () {
    return {
      timeFix: timeFix(),
      avatar: '',
      user: {},
      loading: false,
      radarLoading: true,
      activities: [],
      warningList: [],
      correctErrorList: [],
      busy: false,
      warnLoading: false,
      pagination: {
        onChange: page => {
          this.pagination.current = page
          this.getWarningList({ size: 6, current: page })
        },
        pageSize: 6,
        current: 1,
        total: 0
      }
    }
  },
  computed: {
    ...mapState({
      username: (state) => state.user.username,
      welcome: (state) => state.user.welcome
    }),
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  created () {
    this.user = this.userInfo
    this.avatar = this.userInfo.avatar
  },
  mounted () {
    this.getWarningList({ size: 6, current: 1 })
  },
  methods: {
    getWarningList (data) {
      this.loading = true
      getPage(data).then(res => {
        this.warningList = res.data.records
        this.pagination.total = +res.data.total
        this.loading = false
      }).catch(err => {
        this.$message.error(err.msg)
        this.loading = false
      })
    },
    // 点击收到时触发
    receive (item) {
      // 修改状态
      receive(item.id).then().catch(err => this.$message.error(err.msg))
      // 刷新列表
      this.getWarningList()
    },
    handleCancel () {

    }
  }
}
</script>

<style lang="less" scoped>
  .project-list {

    .card-title {
      font-size: 0;

      a {
        color: rgba(0, 0, 0, 0.85);
        margin-left: 12px;
        line-height: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;

        &:hover {
          color: #1890ff;
        }
      }
    }

    .card-description {
      color: rgba(0, 0, 0, 0.45);
      height: 44px;
      line-height: 22px;
      overflow: hidden;
    }

    .project-item {
      display: flex;
      margin-top: 8px;
      overflow: hidden;
      font-size: 12px;
      height: 20px;
      line-height: 20px;

      a {
        color: rgba(0, 0, 0, 0.45);
        display: inline-block;
        flex: 1 1 0;

        &:hover {
          color: #1890ff;
        }
      }

      .datetime {
        color: rgba(0, 0, 0, 0.25);
        flex: 0 0 auto;
        float: right;
      }
    }

    .ant-card-meta-description {
      color: rgba(0, 0, 0, 0.45);
      height: 44px;
      line-height: 22px;
      overflow: hidden;
    }
  }

  .item-group {
    padding: 20px 0 8px 24px;
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.65);
      display: inline-block;
      font-size: 14px;
      margin-bottom: 13px;
      width: 25%;
    }
  }

  .members {
    a {
      display: block;
      margin: 12px 0;
      line-height: 24px;
      height: 24px;

      .member {
        font-size: 14px;
        color: rgba(0, 0, 0, .65);
        line-height: 24px;
        max-width: 100px;
        vertical-align: top;
        margin-left: 12px;
        transition: all 0.3s;
        display: inline-block;
      }

      &:hover {
        span {
          color: #1890ff;
        }
      }
    }
  }

  .mobile {

    .project-list {

      .project-card-grid {
        width: 100%;
      }
    }

    .more-info {
      border: 0;
      padding-top: 16px;
      margin: 16px 0 16px;
    }

    .headerContent .title .welcome-text {
      display: none;
    }
  }

  .demo-infinite-container {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: auto;
    padding: 8px 24px;
    height: 300px;
  }

  .demo-loading-container {
    position: absolute;
    bottom: 40px;
    width: 100%;
    text-align: center;
  }

</style>
